<form [formGroup]="formGroup" (submit)="isFormValid()" fxLayout="column" fxLayoutAlign="center center">
 
  <mat-toolbar fxLayout="row">
    <button mat-icon-button [matTooltip]="'LABEL_CLOSE' | translate" (click)="confirmChanges()" type="button">
      <mat-icon svgIcon="close"></mat-icon>
    </button>
    <span fxFlex></span>
    <span class="mat-detail-header text-align-center">
      {{ data?.id ? ('LABEL_EDIT_TYPE' | translate : { type: 'LABEL_GROUP' | translate }) : ('LABEL_ADD_NEW' | translate : { type: 'LABEL_GROUP' | translate }) }}
    </span>
    <span fxFlex></span>
    <button mat-icon-button [matTooltip]="'LABEL_SAVE' | translate" type="submit" [disabled]="disableSaveBtn()">
      <mat-icon svgIcon="check"></mat-icon>
    </button>
  </mat-toolbar>
 
  <div fxLayout="column" class="padding-25" fxFlexFill>
    <!-- code -->
    <div fxLayout>
      <mat-form-field>
        <input
          #code
          matInput
          required
          autocomplete="off" 
          formControlName="code" 
          [placeholder]="'LABEL_CODE' | translate"
          >

        <mat-error *ngIf="formGroup.get('code').hasError('required')">
          {{ 'MSG_FIELD_REQUIRED' | translate }}
        </mat-error>  

        <mat-error *ngIf="formGroup.get('code').hasError('maxlength')">
          {{ 'MSG_MAXLENGTH' | translate: {length: '20'} }}
        </mat-error>  
                
        <mat-error *ngIf="formGroup.get('code').hasError('pattern')">
          {{ 'MSG_NO_SPECIAL_CHARS' | translate }}
        </mat-error> 
      </mat-form-field>
    </div>
 
    <!-- description -->
    <div fxLayout>
      <mat-form-field>
        <input 
          matInput
          required
          #description 
          autocomplete="off" 
          formControlName="description" 
          [placeholder]="'LABEL_DESCRIPTION' | translate"
          >

        <mat-error *ngIf="formGroup.get('description').hasError('required')">
          {{ 'MSG_FIELD_REQUIRED' | translate }}
        </mat-error>  

        <mat-error *ngIf="formGroup.get('description').hasError('maxlength')">
          {{ 'MSG_MAXLENGTH' | translate: {length: '250'} }}
        </mat-error>
      </mat-form-field>
    </div>

    <!-- Island Group -->
    <ng-container>
      <esc-generic-dropdown
        class="width-100" 
        [loading]="loading"
        [getMore]="getMore"
        [isRequired]="true"
        [arrayName]="'islandGroups'"
        [dropDownData]="islandGroups"
        [dropdownType]="'islandGroup'"
        [dropdownLabel]="'Island Group'"
        [doesntExistLabel]="'Island Group'"
        [requiredError]="islandGroupRequired"
        [previousData]="formGroup.get('islandGroup').value"
        (fetchData)="getData($event)"
        (optionSelected)="islandGroupSelected($event)"
        (clearDropDownData)="islandGroups = []"
        [disabled]="isFormDisabled"
        >
      </esc-generic-dropdown>
    </ng-container>

    <!-- Group Type -->
    <ng-container>
      <esc-generic-dropdown
        class="width-100" 
        [loading]="loading"
        [getMore]="getMore"
        [isRequired]="true"
        [arrayName]="'groupTypes'"
        [dropDownData]="groupTypes"
        [dropdownType]="'groupType'"
        [dropdownLabel]="'Group Type'"
        [doesntExistLabel]="'Group Type'"
        [requiredError]="groupTypeRequired"
        [previousData]="formGroup.get('groupType').value"
        (fetchData)="getData($event)"
        (optionSelected)="groupTypeSelected($event)"
        (clearDropDownData)="groupTypes = []"
        [disabled]="isFormDisabled"
        >
      </esc-generic-dropdown>
    </ng-container>

    <!-- District -->
    <ng-container>
      <esc-generic-dropdown
        class="width-100" 
        [loading]="loading"
        [getMore]="getMore"
        [isRequired]="districtRequired"
        [arrayName]="'districts'"
        [dropDownData]="districts"
        [dropdownType]="'district'"
        [dropdownLabel]="'District'"
        [doesntExistLabel]="'District'"
        [requiredError]="districtRequired"
        [previousData]="formGroup.get('district').value"
        (fetchData)="getData($event)"
        (optionSelected)="districtSelected($event)"
        (clearDropDownData)="districts = []"
        [disabled]="isFormDisabled"
        >
      </esc-generic-dropdown>
    </ng-container>
 
    <!-- status / is_active -->
    <mat-checkbox formControlName="status">Active</mat-checkbox>

  </div>
</form>